import React, { useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setOverlay } from '../../actions'
import { useOnClickOutside } from '../../hooks'
import './styles.scss'

const Overlay = () => {
  const { isOpen, type, props: allProps } = useSelector((state) => state.general.overlay)
  const dispatch = useDispatch()

  const hide = () => dispatch(setOverlay({ isOpen: false }))
  const containerRef = useRef()
  useOnClickOutside(containerRef, () => hide(), isOpen)

  const props = { ...allProps, hide }

  const render = () => {
    switch (type) {
      case 'vehicleComments':
      case 'vehicleFiles':
        return <div {...props} />
      default:
        return null
    }
  }

  return (
    <div className={`overlay-container ${isOpen && 'open'}`}>
      <div className="overlay-inner-container" ref={containerRef}>
        {render()}
      </div>
    </div>
  )
}

export default Overlay
